import React from 'react';

import IMG_ANY_TIME_SLOT from 'assets/images/online-booking/availability-any-time-slot.png';
import IMG_ON_THE_HOUR from 'assets/images/online-booking/availability-on-the-hour.png';
import IMG_ON_THE_HOUR_OR_HALF from 'assets/images/online-booking/availability-on-the-hour-or-half.png';
import IMG_REDUCE_WHITE_SPACE from 'assets/images/online-booking/availability-reduce-white-space.png';
import ImageOptionsInput from 'components/form/ImageOptionsInput.component';
import { useTranslation } from 'providers/GILT.provider';
import C from 'utils/values/constant.util';

const OPTIONS = C([
  {
    id: 'on_the_hour',
    labelTranslateKey: 'onlineBooking.bookingTimings.availability.setting1',
    src: IMG_ON_THE_HOUR,
    value: 'on_the_hour',
  },
  {
    id: 'on_the_hour_or_half_hour',
    labelTranslateKey: 'onlineBooking.bookingTimings.availability.setting2',
    src: IMG_ON_THE_HOUR_OR_HALF,
    value: 'on_the_hour_or_half_hour',
  },
  {
    id: 'smart_algo',
    labelTranslateKey: 'onlineBooking.bookingTimings.availability.setting3',
    src: IMG_REDUCE_WHITE_SPACE,
    value: 'smart_algo',
  },
  {
    id: 'any_time',
    labelTranslateKey: 'onlineBooking.bookingTimings.availability.setting4',
    src: IMG_ANY_TIME_SLOT,
    value: 'any_time',
  },
]);

const WidgetAvailabilitySettings = (props) => {
  const { t } = useTranslation();

  const widgetOptions = OPTIONS.map((option) => ({
    ...option,
    description: t(option.labelTranslateKey),
  }));

  return <ImageOptionsInput {...props} options={widgetOptions} columns="two" />;
};

export default WidgetAvailabilitySettings;
